import {defineStore} from 'pinia';
import {ModuleAccountTransfer} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import accountTransferAPI from '@/apis/di/accountTransferAPI';

const accountTransferStore = new BaseDictionaryStore(accountTransferAPI);

export const useAccountTransferStore = defineStore(ModuleAccountTransfer, {
  state: () => ({
    ...accountTransferStore.state,
    _config: {
      key: 'account_transfer_id',
      code: 'account_transfer_code',
      table: 'di_account_transfer',
      moduleName: 'Tài khoản kết chuyển',
      quickFollow: 'active',
    },
    moduleName: 'accountTransfer',
  }),
  actions: {
    ...accountTransferStore.action,

    /**
     * Thực hiện cập nhật đầu 009
     * pdtai 13.09.2023
     */
    async updateAccount009() {
      const me = this;
      await me.loadFullCache({ remoteVersion: Math.floor(Math.random() * 1000) + 2 });
    }
  },
  getters: {
    ...accountTransferStore.getters,
  },
});
